import api from 'Application/api/api';

const getTemplateGroup = (id, cancelToken = null) =>
    api.get(`project-manager/template-groups/${id}`, {
        params: {},
        cancelToken,
    });

export default getTemplateGroup;
